export const aciAirplaneOneWay = {
    iconName: 'airplane-one-way',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M10.374 6.873a.39.39 0 01.19-.05H12.58l4.614 5.538a.566.566 0 00.435.204h1.914a2.305 2.305 0 010 4.609H6.683a1.348 1.348 0 01-1.307-1.021l-1.254-5.017a.391.391 0 01.38-.485h2.251l.8 1.6a.566.566 0 00.507.314h3.827a.566.566 0 00.506-.82l-2.178-4.357a.388.388 0 01.16-.515zm.192-1.182a1.522 1.522 0 00-1.363 2.204l1.768 3.537H8.41l-.8-1.6a.566.566 0 00-.507-.313H4.502a1.523 1.523 0 00-1.478 1.89l1.254 5.018a2.48 2.48 0 002.405 1.879h12.859a3.437 3.437 0 100-6.874h-1.649L13.28 5.895a.566.566 0 00-.435-.204h-2.278z',
                fill: 'currentColor',
            },
        },
    },
};
